import type { Step } from "react-joyride";

/**
 * Versione 2 (2026-09-12): sezione «Utenze fornitore», con le credenziali che
 * solo l'Affiliato può mettere (il passo si mostra dove il pulsante esiste).
 */
export const profiloStaffVersion = 2;

export const profiloStaffSteps: Step[] = [
  {
    target: '[data-tour="profilo-dati"]',
    title: "Dati account",
    content: (
      <p>
        Nome, email, ruolo (Operatore / Affiliato / Supervisore) e agenzia. Sono
        dati in sola lettura: per modifiche chiedi all'amministratore.
      </p>
    ),
    placement: "bottom",
    skipBeacon: true,
  },
  {
    target: '[data-tour="profilo-utenze"]',
    title: "Utenze fornitore",
    content: (
      <p>
        Con quale utenza il portale invia le tue pratiche a ogni fornitore, e se
        quel collegamento è in piedi. Se dice che l'utenza non è assegnata, le
        pratiche restano in coda: lo sistema l'amministratore.
      </p>
    ),
    placement: "bottom",
    skipBeacon: true,
  },
  {
    target: '[data-tour="profilo-credenziali"]',
    title: "Le credenziali del fornitore",
    content: (
      <p>
        Password e codice dell'app di autenticazione si mettono da qui. Al
        salvataggio il portale prova subito ad accedere: chi in agenzia è dentro
        A2A con la stessa utenza viene disconnesso.
      </p>
    ),
    placement: "left",
    skipBeacon: true,
  },
  {
    target: '[data-tour="profilo-password"]',
    title: "Cambia password",
    content: (
      <p>
        La password del portale, almeno otto caratteri. È altra cosa dalle
        credenziali del fornitore qui sopra.
      </p>
    ),
    placement: "top",
    skipBeacon: true,
  },
];
